// extracted by mini-css-extract-plugin
export default {"fs":"_11acedb81c c6e7c5b40f"};